export { default } from './EvaluationRedemptionModal';
